import { render } from "./Desi.vue?vue&type=template&id=826d3df6"
import script from "./Desi.vue?vue&type=script&lang=js"
export * from "./Desi.vue?vue&type=script&lang=js"

import "./Desi.vue?vue&type=style&index=0&id=826d3df6&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__